import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import WriteComponent from './routes/Write'

import asyncComponent from '../../../util/asyncComponent'

const AppModule = ({match}) => <Switch>
  <Redirect exact from={`${match.url}/`} to={`${match.url}/write`}/>
  <Route path={`${match.url}/setup`} component={asyncComponent(() => import('./routes/Setup'))}/>
  <Route path={`${match.url}/write/:sceneId?/:slateId?/:takeId?`} render={(props) => (<WriteComponent {...props}/>)}/>
  <Route path={`${match.url}/view`} component={asyncComponent(() => import('./routes/View'))}/>
</Switch>

export default AppModule



// WEBPACK FOOTER //
// ./app/routes/ScriptLog/index.js